import React, {FC, ReactNode} from "react";

interface ContentContainerProps {
  children: ReactNode
  size?: "sm"|"md"|"lg"|'xl'|'full' // defaults to MD
}

export const ContentContainer: FC<ContentContainerProps> = props => {
  const maxWidth = {
    "sm": "max-w-(--breakpoint-sm) mx-auto",
    "md": "max-w-(--breakpoint-lg) mx-auto",
    "lg": "max-w-(--breakpoint-xl) mx-auto",
    'xl': "max-w-(--breakpoint-2xl) mx-auto",
    "full": "w-full"
  }[props.size ?? "md"]
  return <div className={`${maxWidth}`}>
    {props.children}
  </div>
}